<template>
  <div class="body-container quiz"
    v-bind:class="{
      'one':   currentStage === 1,
      'two':   currentStage === 2,
      'three': currentStage === 3,
      'four':  currentStage === 4,
      'five':  currentStage === 5,
      'six':   currentStage === 6
    }"
  >

    <transition name="fade">
      <div class="quiz-stage" v-if="currentStage === 1">
        <!-- Stage one -->
        <div class="content-container">
          <p><span v-translate>Choose a photo</span></p>
          <div class="custom-carousel">
            <div class="item" @click="updateQuiz(0,1), updateQuizPoints(1)" v-bind:class="{active: quizChoices[0] === 1}">
              <img src="/data/images/stage-1/1.png">
            </div>
            <div class="item" @click="updateQuiz(0,0), updateQuizPoints(2)" v-bind:class="{active: quizChoices[0] === 2}">
              <img src="/data/images/stage-1/2.png">
            </div>
            <div class="item" @click="updateQuiz(0,3), updateQuizPoints(3)" v-bind:class="{active: quizChoices[0] === 3}">
              <img src="/data/images/stage-1/3.png">
            </div>
            <div class="item" @click="updateQuiz(0,2), updateQuizPoints(4)" v-bind:class="{active: quizChoices[0] === 4}">
              <img src="/data/images/stage-1/4.png">
            </div>
            <div class="item" @click="updateQuiz(0,4), updateQuizPoints(5)" v-bind:class="{active: quizChoices[0] === 5}">
              <img src="/data/images/stage-1/5.png">
            </div>
          </div>
        </div>
        <div class="bg-image one"></div>
      </div>
    </transition>
    <transition name="fade">
      <div class="quiz-stage" v-if="currentStage === 2">
        <div class="content-container">
          <p><span v-translate>Where would you rather be on a Friday night?</span></p>
          <ul class="vertial-question-container">
            <li @click="updateQuiz(1,1), updateQuizPoints(1)" v-bind:class="{active: quizChoices[1] === 1}">
              <span v-translate>My couch in pjs - cuddled up with my dog</span>
            </li>
            <li @click="updateQuiz(1,2), updateQuizPoints(2)" v-bind:class="{active: quizChoices[1] === 2}">
              <span v-translate>At the club, flying on my own</span>
            </li>
            <li @click="updateQuiz(1,3), updateQuizPoints(3)" v-bind:class="{active: quizChoices[1] === 3}">
              <span v-translate>Wherever my friends are</span>
            </li>
            <li @click="updateQuiz(1,4), updateQuizPoints(4)" v-bind:class="{active: quizChoices[1] === 4}">
              <span v-translate>A nice restaurant with my boo</span>
            </li>
            <li @click="updateQuiz(1,5), updateQuizPoints(5)" v-bind:class="{active: quizChoices[1] === 5}">
              <span v-translate>In my room, writing in my diary</span>
            </li>
          </ul>
        </div>
        <div class="bg-image two"></div>
      </div>
    </transition>
    <transition name="fade">
      <div class="quiz-stage" v-if="currentStage === 3">
        <div class="content-container">
          <p><span v-translate>You’re at an amusement park. You…</span></p>
          <ul class="vertial-question-container">
            <li @click="updateQuiz(2,1), updateQuizPoints(2)" v-bind:class="{active: quizChoices[2] === 1}">
              <span v-translate>Head straight to the highest ride</span>
            </li>
            <li @click="updateQuiz(2,2), updateQuizPoints(4)" v-bind:class="{active: quizChoices[2] === 2}">
              <span v-translate>Win a prize for that special someone</span>
            </li>
            <li @click="updateQuiz(2,3), updateQuizPoints(1)" v-bind:class="{active: quizChoices[2] === 3}">
              <span v-translate>Get chicken tenders with the squad</span>
            </li>
            <li @click="updateQuiz(2,4), updateQuizPoints(3)" v-bind:class="{active: quizChoices[2] === 4}">
              <span v-translate>Get my face painted</span>
            </li>
            <li @click="updateQuiz(2,5), updateQuizPoints(5)" v-bind:class="{active: quizChoices[2] === 5}">
              <span v-translate>I don’t go to amusement parks - too many germs</span>
            </li>
          </ul>
        </div>
        <div class="bg-image three"></div>
      </div>
    </transition>
    <transition name="fade">
      <div class="quiz-stage" v-if="currentStage === 4">
        <div class="content-container">
          <p><span v-translate>What is your ideal vacation?</span></p>
          <ul class="vertial-question-container">
            <li @click="updateQuiz(3,1), updateQuizPoints(3)" v-bind:class="{active: quizChoices[3] === 1}">
              <span v-translate>City</span>
            </li>
            <li @click="updateQuiz(3,2), updateQuizPoints(1)" v-bind:class="{active: quizChoices[3] === 2}">
              <span v-translate>Beach</span>
            </li>
            <li @click="updateQuiz(3,3), updateQuizPoints(2)" v-bind:class="{active: quizChoices[3] === 3}">
              <span v-translate>Safari</span>
            </li>
            <li @click="updateQuiz(3,4), updateQuizPoints(4)" v-bind:class="{active: quizChoices[3] === 4}">
              <span v-translate>Jungle Cabana</span>
            </li>
            <li @click="updateQuiz(3,5), updateQuizPoints(5)" v-bind:class="{active: quizChoices[3] === 5}">
              <span v-translate>Silent Retreat</span>
            </li>
          </ul>
        </div>
        <div class="bg-image four"></div>
      </div>
    </transition>
    <transition name="fade">
      <div class="quiz-stage" v-if="currentStage === 5">
        <div class="content-container">
          <p><span v-translate>What city would you like to live in?</span></p>
          <ul class="vertial-question-container">
            <li @click="updateQuiz(4,1), updateQuizPoints(4)" v-bind:class="{active: quizChoices[4] === 1}">
              <span v-translate>Paris</span>
            </li>
            <li @click="updateQuiz(4,2), updateQuizPoints(2)" v-bind:class="{active: quizChoices[4] === 2}">
              <span v-translate>Milan</span>
            </li>
            <li @click="updateQuiz(4,3), updateQuizPoints(3)" v-bind:class="{active: quizChoices[4] === 3}">
              <span v-translate>Berlin</span>
            </li>
            <li @click="updateQuiz(4,4), updateQuizPoints(1)" v-bind:class="{active: quizChoices[4] === 4}">
              <span v-translate>Montreal</span>
            </li>
            <li @click="updateQuiz(4,5), updateQuizPoints(5)" v-bind:class="{active: quizChoices[4] === 5}">
              <span v-translate>New York</span>
            </li>
          </ul>
        </div>
        <div class="bg-image five"></div>
      </div>
    </transition>
    <transition name="fade">
      <div class="quiz-stage" v-if="currentStage === 6">
        <div class="content-container">
          <p><span v-translate>Pick one of these movies to watch</span></p>
          <ul class="vertial-question-container">
            <li @click="updateQuiz(5,1), updateQuizPoints(1)" v-bind:class="{active: quizChoices[5] === 1}">
              <span v-translate>Beauty and the Beast</span>
            </li>
            <li @click="updateQuiz(5,2), updateQuizPoints(2)" v-bind:class="{active: quizChoices[5] === 2}">
              <span v-translate>Stuart Little</span>
            </li>
            <li @click="updateQuiz(5,3), updateQuizPoints(3)" v-bind:class="{active: quizChoices[5] === 3}">
              <span v-translate>Deadpool 2</span>
            </li>
            <li @click="updateQuiz(5,4), updateQuizPoints(1)" v-bind:class="{active: quizChoices[5] === 4}">
              <span v-translate>Up Close and Personal</span>
            </li>
            <li @click="updateQuiz(5,5), updateQuizPoints(5)" v-bind:class="{active: quizChoices[5] === 5}">
              <span v-translate>Sleepless in Seattle</span>
            </li>
          </ul>
        </div>
        <div class="bg-image six"></div>
      </div>
    </transition>

    <div class="quiz-controls">
      <div class="nav-buttons">
        <transition name="fade" v-if="currentStage === 6">
          <span class="discover-button" ref="discover-button"
            v-if="
            quizChoices[4] != 0
            && quizChoices[1] != 0
            && quizChoices[2] != 0
            && quizChoices[3] != 0
            && quizChoices[4] != 0
            && quizChoices[5] != 0
            "
            @click="discoverCeline()"
          >
            <span v-translate>Discover your inner Celine</span>
          </span>
        </transition>
        <span class="prev"
          @click="changeQuestion('prev')"
          v-bind:class="{disabled: currentStage === 1}"
          v-if="currentStage > 1 && quizChoices[5] === 0"
        >
          <svg width="24px" height="38px" viewBox="0 0 24 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Previous-Button" transform="translate(-16.000000, -9.000000)" fill-rule="nonzero" stroke="#FFFFFF">
                      <polygon id="Forward" transform="translate(28.000000, 28.000000) scale(-1, 1) translate(-28.000000, -28.000000) " points="20.5799056 10 16 14.245 30.8401888 28 16 41.755 20.5799056 46 40 28"></polygon>
                  </g>
              </g>
          </svg>
        </span>
      </div>
      <div class="quiz-pagination">
        <span v-bind:class="{active: currentStage >= 1}"></span>
        <span v-bind:class="{active: currentStage >= 2}"></span>
        <span v-bind:class="{active: currentStage >= 3}"></span>
        <span v-bind:class="{active: currentStage >= 4}"></span>
        <span v-bind:class="{active: currentStage >= 5}"></span>
        <span v-bind:class="{active: currentStage >= 6, active: quizChoices[4] != 0}"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { apple_developer_token, ae_redirect_url, spotify_client_key, spotify_redirect_url } from '@/meconfig.js';


export default {
  name: 'Quiz',
  data: function () {
    return {
      connected: false,
      musicService: null,
      currentStage: 1,
      quizChoices: [0,0,0,0,0,0],
      quizPoints: [0,0,0,0,0],
    }
  },
  mounted: function() {
    window.quizStarted = true;
    // window.userType = 'Spotify';

    if(!window.quizStarted || window.quizStarted !== true){
        this.$router.push('quiz');
    }
    // if(!window.userType){
    //   this.$router.push('/');
    // }
  },
  methods: {
    //Update the points / type the user is
    updateQuizPoints: function(increaseType){
      var increaseType = increaseType -1;
      var self = this;
      for (var i = 0; i < self.quizPoints.length; i++) {
        var currentValue = self.quizPoints[i];
        if(currentValue < 0){
        //  self.$set(self.quizPoints, i, currentValue - 10);
        }
      }
      var currentValue = self.quizPoints[increaseType];
      this.$set(self.quizPoints, increaseType, currentValue + 10);
      this.generateUserType();
    },

    //Generate user type
    generateUserType: function(){
      // GUIDE TO POINTS
      // 0 = Bestie
      // 1 = Fierce
      // 2 = Life of the party
      // 3 = ooh la la
      // 4 = all the feels


      var highestScoring = this.quizPoints.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);
      var celineType;
      if(highestScoring === 0){
        celineType = 'bestie';
      }
      if(highestScoring === 1){
        celineType = 'fierce';
      }
      if(highestScoring === 2){
        celineType = 'lifeoftheparty';
      }
      if(highestScoring === 3){
        celineType = 'oohlala';
      }
      if(highestScoring === 4){
        celineType = 'allthefeels';
      }
      if(celineType != null){
        window.celineType = celineType;
      }
    },

    //Change the question
    changeQuestion: function(direction){
      var self = this;
      if(direction === 'prev'){
        if(self.currentStage >= 2){
          setTimeout(
            function() {
              self.currentStage--;
            }, 400);
          document.getElementById('header').scrollIntoView({
            behavior: "smooth"
          });
        }
      }
      if(direction === 'next'){
        if(self.currentStage <= 5){
          setTimeout(
            function() {
              self.currentStage++;
            }, 400);
          document.getElementById('header').scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    },


    //Update the quiz
    updateQuiz: function(index,value){
      var self = this;
      this.$set(self.quizChoices, index, value);
      console.log(self.currentStage);
      if(self.currentStage <= 5){
        setTimeout(
          function() {
            self.currentStage++;
          }, 400);
        document.getElementById('header').scrollIntoView({
          behavior: "smooth"
          });
      } else if(self.currentStage === 6) {
        document.getElementById('footer').scrollIntoView({
          behavior: "smooth"
          });
      }
    },

    //Discover what Celine you are
    discoverCeline: function(){
      window.quizCompleted = true;
      this.$router.push({ name: 'result', params: {celineType: window.celineType} });
    }

  }
}
</script>


<!-- THIS STYLING NEEDS DELETING WHEN YOU BUILD -->
<style lang="scss" scoped>

  #app {
    box-sizing: border-box;
    background: #eee;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  // Global transition for Fade's
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  //All pages wraped in this, to help transitions
  .body-container.quiz {
    flex-direction: column;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    align-items: center;
    overflow: hidden;
    background-position: right;
    position: relative;

    @media screen and (max-width: 900px){
      padding-bottom: 0;
      background-position: top center;
      background-size: 100%;
      padding-right: 0;
      padding-top: 260px;
    }

    @media screen and (max-width: 800px){
      height: 580px;
    }

    p{
      margin: 0 auto !important;
      max-width: 610px;
    }

    //BG IMAGES
    &.one {
      background-color: #F86050;
      h1{
        color: #1058A8;
      }
      p{
        color: #1058A8;
        width: 50% !important;
      }
      @media screen and (max-width: 900px){
        border-top: 50px #1058A8 solid;
        p{
          width: 100% !important;
        }
      }
    }
    &.two {
      background-color: #101830;
      h1{
        color: #F0E0D8;
      }
      p{
        color: #F0E0D8;
      }
      .vertial-question-container li{
        border-color: #81ADD2 !important;
      }
      @media screen and (max-width: 900px){
        border-top: 50px #81ADD2 solid;
        min-height: 790px;
      }
    }
    &.three {
      background-color: #D08080;
      h1{
        color: #184080;
      }
      p{
        color: #184080;
      }
      .vertial-question-container li{
        border-color: #184080 !important;
      }
      @media screen and (max-width: 900px){
        border-top: 50px #184080 solid;
      }
    }
    &.four {
      background-color: #D8A07C;
      h1{
        color: #141414;
      }
      p{
        color: #141414;
      }
      .vertial-question-container li{
        border-color: #141414 !important;
      }
      @media screen and (max-width: 900px){
        border-top: 50px #141414 solid;
      }
    }
    &.five {
      background-color: #CCA86C;
      h1{
        color: #4A2620;
      }
      p{
        color: #4A2620;
      }
      .vertial-question-container li{
        border-color: #4A2620 !important;
      }
      @media screen and (max-width: 900px){
        border-top: 50px #4A2620 solid;
      }
    }
    &.six {
      background-color: #280850;
      h1{
        color: #F860D0;
      }
      p{
        color: #F860D0;
      }
      @media screen and (max-width: 900px){
        border-top: 50px #909CA8 solid;
      }
    }

    // QUIZ CONTENT CONTAINER
    .quiz-stage {
      display: flex;
      flex: 1;
      width: 100%;
      padding-right: 50%;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      @media screen and (max-width: 900px){
        position: static !important;
        padding-right: 0;
      }

      .bg-image {
        position: absolute;
        right: 0;
        width: 50%;
        height: 100%;
        background-size: cover;
        z-index: 10;

        &.one {
          background-image: url('/data/images/quiz-bg/1.png');
        }
        &.two {
          background-image: url('/data/images/quiz-bg/2.png');
        }
        &.three {
          background-image: url('/data/images/quiz-bg/3.png');
        }
        &.four {
          background-image: url('/data/images/quiz-bg/4.png');
        }
        &.five {
          background-image: url('/data/images/quiz-bg/5.png');
        }
        &.six {
          background-image: url('/data/images/quiz-bg/6.png');
        }

        @media screen and (max-width: 900px){
          height: 220px;
          top: 0;
          left: 0;
          width: 100%;

          &.one {
            background-position: center center;
          }
          &.two {
            background-position: center center;
          }
          &.three {
            background-position: center center;
          }
          &.four {
            background-position: center 40%;
          }
          &.five {
            background-position: center center;
          }
          &.six {
            background-position: center 40%;
          }

        }
      }


      @media screen and (max-width: 900px){
        align-items: start;
        display: block;
        position: relative;
      }

      p {
        cursor: default;
        width: 100%;
        font-size: 16px;
        text-align: center;

        @media screen and (max-height: 720px){
          margin-bottom: 10px;
        }
      }

      .content-container {
        position: static;
        padding-bottom: 100px;
        @media screen and (max-width: 900px){
          padding-bottom: 0;
          max-width: 90%;
          margin: 0 5%;
        }
        p{
          font-weight: 900;
          padding-top: 10vh;
          padding-bottom: 20px;
        }
      }

      .custom-carousel {
        display: inline-block;
        max-width: 1024px;
        width: 100%;
        margin: 0 auto;
        text-align: center;


        .item {
          display: inline-block;
          width: 160px;
          height: auto;
          border-radius: 6px;
          overflow: hidden;
          margin: 0 15px 15px;
          border: 8px solid #fff;
          cursor: pointer;
          transition: border-color 0.4s;

          @media screen and (max-width: 1100px){
            width: 120px;
          }

          @media screen and (max-width: 900px){
            border-width: 2px;
          }

          img {
            width: 100%;
            height: auto;
            float: left;
            margin: 0;
          }

          &:hover,
          &.active {
            border-color: #1058A8;
          }
        }
      }

      .vertial-question-container {
        padding: 0;
        margin: 0 auto;
        width: 420px;
        @media screen and (max-width: 900px){
          width: 100%;
        }
        li {
          display: block;
          widht: 100%;
          line-height: 42px;
          height: auto;
          font-weight: 600;
          border: 1px solid #fff;
          margin: 0 0 15px 0;
          font-size: 12px;
          padding: 9px 5px;
          line-height: 22px;
          cursor: pointer;
          transition-delay: 0.2s;
          transition: all 0.3s;

          @media screen and (max-width: 800px){
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            margin: 0 0 10px 0;
            padding: 8px 0;
          }

          @media screen and (max-width: 600px){
            font-size: 12px;
            height: auto;
            line-height: normal;
          }

          @media screen and (max-height: 600px){
            font-size: 11px;
            height: auto;
            line-height: 15px;
            margin: 0 0 7px 0;
          }

          @media not all and (hover: none) {
            &:hover{
              background: #fff;
              color: #000;
              transition: all 0.3s;
            }
          }

          &.active {
            background: #fff;
            color: #000;
            transition: all 0.3s;
          }
        }
      }
    }

    .quiz-header {
      display: block;
      align-self: flex-start;
      color: #fff;
      width: 100%;
      height: 190px;
      justify-content: center;
      align-items: center;

      h1 {
        display: block;
        font-size: 2em;
        font-weight: 900;
        cursor: default;

        span {
          display: block;
          width: 100%;
          clear: both;
        }

        b {
          font-size: 2.2em;
          line-height: 0.9em;
        }

        @media screen and (max-height: 720px){
          font-size: 1.4em;
          height: auto;
        }
      }
    }

    .quiz-controls {
      position: fixed;
      bottom: 60px;
      left: 0;
      width: 50%;
      align-self: flex-end;
      z-index: 25;

      @media screen and (max-width: 1100px){
        bottom: 110px;
      }

      .missing-question {
        p {
          color: #fff;
        }

        span {
          border: 2px solid #fff;
          color: #fff;
          margin: 10px auto;
          padding: 0 10px;
          height: 40px;
          line-height: 40px;
        }
      }


      .discover-button {
        display: inline-block;
        margin: 0 auto;
        border-radius: 6px;
        background: #000;
        color: #fff;
        height: 56px;
        line-height: 58px;
        width: 322px;
        font-weight: 600;
        text-transform: uppercase;
        transition: background 0.3s;
        transition-delay: 0.1s;
        cursor: pointer;

        -webkit-animation: Pulse 1s infinite ease-in-out;
        -o-animation: Pulse 1s infinite ease-in-out;
        -ms-animation: Pulse 1s infinite ease-in-out;
        -moz-animation: Pulse 1s infinite ease-in-out;
        animation: Pulse 1s infinite ease-in-out;

        &:hover {
          background: #2F70A8;
          transition-delay: 0s;
        }
      }

      .nav-buttons {
        display: block;
        width: 100%;
        margin-bottom: 24px;

        .prev,
        .next {
          display: inline-block;
          margin: 0 16px;
          height: 56px;
          width: 56px;
          padding-top: 8px;
          text-align: center;
          cursor: pointer;
          opacity: 0.5;
          border: 1px solid #fff;
          transition: opacity 0.3s;

          &:hover,
          &.active {
            opacity: 1;
          }

          &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
            &:hover {
              opacity: 0.5;
            }
          }
        }
        .prev {
          padding-right: 5px;
        }
        .next {
          padding-left: 5px;
        }
      }

      .quiz-pagination {
        width: 200px;
        display: inline-block;
        margin: 0 auto;
        display: flex;
        text-align: center;

        span {
          display: inline-block;
          width: 14px;
          height: 14px;
          border: 2px solid #fff;
          cursor: default;
          margin: 0 auto;
          transition: background 0.3s;

          &.active {
            background: #fff;
          }
        }
      }
    }




    .content-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 1024px;

      p {
        padding: 0 20px;
        font-size: 32px;
        margin: 0 0 0 0;
        cursor: default;
      }
    }
  }


  @media screen and (max-width: 900px){
    .body-container.quiz {
      position: relative;
      height: auto;
      min-height: 0;
      .quiz-header {
        height: auto;
        h1 {
          font-size: 28px;
          b {
            font-size: 40px;
          }
        }
      }
      .content-container {
        p {
          padding-top: 20px !important;
          font-size:  32px;
          margin: 0;
        }
      }
      .quiz-controls {
        position: static;
        width: 100%;
        padding: 20px 0;
        margin: 0;

        .discover-button {
          max-width: 90%;
          font-size: 14px;
        }

        .nav-buttons {
          margin-bottom: 15px;
          span.prev,
          span.next {
            width: 30px;
            height: 30px;
            padding: 4px 0 0 0;

            svg {
              width: 12px;
              height: auto;
            }
          }
        }
      }
    }

    @media screen and (max-width: 350px){
      .body-container.quiz {
        .content-container {
          p {
            font-size:  28px;
          }
        }
      }
    }
}


@media screen and (max-height: 700px ) and (min-width: 900px){
  .body-container.quiz .quiz-header h1 {
    font-size: 1.4em;
  }
  .body-container.quiz .content-container p {
    font-size:  46px;
    margin: 0 0 0 0;
  }
  .body-container.quiz .quiz-controls .nav-buttons {
    margin-bottom: 13px;
    .prev {
      width: 40px;
      height: 40px;
      padding-top: 7px;
      svg {
        width: 16px;
        height: auto;
      }
    }
    .discover-button {
      height: 35px;
      line-height: 36px;
      font-size: 13px;
      width: auto;
      padding: 0 20px;
      margin-bottom: 6px;
    }
  }
}


@-webkit-keyframes Pulse {
	0% { -webkit-box-shadow: 0 0 14px rgba(255,255,255,0.2); }
	50% { -webkit-box-shadow: 0 0 14px rgba(255,255,255,0.99); }
	100% { -webkit-box-shadow: 0 0 14px rgba(255,255,255,0.2); }
}

@keyframes Pulse {
	0% { box-shadow: 0 0 14px rgba(255,255,255,0.2); }
	50% { box-shadow: 0 0 14px rgba(255,255,255,0.99); }
	100% { box-shadow: 0 0 14px rgba(255,255,255,0.2); }
}
</style>
